(function () {
  var root = window.MuscleSmith || {};
  var moneyFormat = root.moneyFormat || '₹{{amount}}';

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    var formatted = amount.toLocaleString('en-IN', {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
    return String(moneyFormat)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount).toLocaleString('en-IN'))
      .replace(/\{\{\s*amount\s*\}\}/g, formatted);
  }

  function perServingText(cents, servings) {
    var count = Number(servings) || 0;
    if (count < 1) return '';
    var each = Math.floor((Number(cents) || 0) / count);
    if (each < 1) return '';
    return formatMoney(each) + '/serving';
  }

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function on(el, event, fn) {
    if (el) el.addEventListener(event, fn);
  }

  function burstConfetti(anchor) {
    var host = document.createElement('div');
    host.className = 'ms-confetti';
    host.setAttribute('aria-hidden', 'true');
    var rect = anchor && anchor.getBoundingClientRect ? anchor.getBoundingClientRect() : null;
    var originX = rect ? rect.left + rect.width / 2 : window.innerWidth / 2;
    var originY = rect ? rect.top + rect.height / 2 : window.innerHeight * 0.4;
    var colors = ['#ff6633', '#ffb199', '#ffd166', '#fff4ea', '#7dcea0', '#5dade2', '#f7dc6f'];
    for (var i = 0; i < 42; i++) {
      var bit = document.createElement('span');
      var angle = (Math.PI * 2 * i) / 42 + Math.random() * 0.35;
      var dist = 72 + Math.random() * 150;
      bit.style.left = originX + 'px';
      bit.style.top = originY + 'px';
      bit.style.background = colors[i % colors.length];
      bit.style.setProperty('--dx', Math.cos(angle) * dist + 'px');
      bit.style.setProperty('--dy', (Math.sin(angle) * dist - 36) + 'px');
      bit.style.setProperty('--rot', (Math.random() * 540 - 270) + 'deg');
      bit.style.width = (5 + Math.random() * 6) + 'px';
      bit.style.height = (7 + Math.random() * 8) + 'px';
      bit.style.borderRadius = Math.random() > 0.45 ? '2px' : '999px';
      host.appendChild(bit);
    }
    document.body.appendChild(host);
    window.setTimeout(function () {
      host.remove();
    }, 1100);
  }

  var FLAVOUR_COLORS = {
    blueberry: '#3b82f6',
    'icy blueberry': '#60a5fa',
    'cold coffee': '#6f4e37',
    coffee: '#6f4e37',
    mocha: '#7a4b32',
    'cookies and cream': '#e8d5b7',
    'orange obsession': '#ff7a00',
    orange: '#ff7a00',
    'watermelon splash': '#e23d4f',
    watermelon: '#e23d4f',
    'magical mango': '#ffb347',
    mango: '#ffb347',
    'imli candy': '#a0522d',
    'pink guava': '#ff6b9d',
    chocolate: '#5d3a1a',
    'creamy chocolate': '#6b3f24',
    'dark chocolate': '#3c1f0f',
    vanilla: '#f5e6c8',
    'american ice cream': '#fff6e0',
    'ice cream': '#fff6e0',
    strawberry: '#e85d75',
    unflavoured: '#d9d4cc',
    unflavored: '#d9d4cc',
    apple: '#7cb342',
    lemon: '#f4d03f',
    pineapple: '#f5c518',
    'fruit punch': '#e11d48',
    'blue raspberry': '#3b82f6',
    'mixed berry': '#c026d3',
    cola: '#3b1f0e',
    'peanut butter': '#d4a017',
  };

  var FLAVOUR_SOFT = {
    'cold coffee': ['#f3ebe3', '#faf6f2'],
    'cookies and cream': ['#f7f0e4', '#fbf8f2'],
    chocolate: ['#f3ebe4', '#faf6f2'],
    vanilla: ['#faf6ec', '#fdfbf5'],
    'american ice cream': ['#fff8ea', '#fffdf8'],
    'ice cream': ['#fff8ea', '#fffdf8'],
    strawberry: ['#fceef1', '#fef7f8'],
    mango: ['#fff3e0', '#fffaf2'],
    'magical mango': ['#fff3e0', '#fffaf2'],
    'orange obsession': ['#fff0e3', '#fff8f1'],
    'watermelon splash': ['#fdeced', '#fff7f7'],
    'imli candy': ['#f4ebe4', '#faf6f2'],
    'pink guava': ['#ffeef4', '#fff7fa'],
    unflavoured: ['#f3f1ed', '#f9f8f6'],
    unflavored: ['#f3f1ed', '#f9f8f6'],
  };

  function normalizeName(name) {
    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isSizeLike(part) {
    return /^\d/.test(String(part || '').trim()) || /\b(\d+\s?)?(kg|g|lb|lbs|ml|l|servings?)\b/i.test(part);
  }

  function parseHex(hex) {
    var raw = String(hex || '').replace('#', '').trim();
    var full = raw.length === 3 ? raw.split('').map(function (ch) { return ch + ch; }).join('') : raw.slice(0, 6);
    if (!/^[0-9a-f]{6}$/i.test(full)) return null;
    return {
      r: parseInt(full.slice(0, 2), 16),
      g: parseInt(full.slice(2, 4), 16),
      b: parseInt(full.slice(4, 6), 16),
    };
  }

  function toHex(r, g, b) {
    function clamp(n) {
      return Math.max(0, Math.min(255, Math.round(n)));
    }
    return '#' + [clamp(r), clamp(g), clamp(b)].map(function (n) {
      return n.toString(16).padStart(2, '0');
    }).join('');
  }

  function mixHex(hex, target, amount) {
    var a = parseHex(hex);
    var b = parseHex(target);
    if (!a || !b) return hex;
    return toHex(a.r + (b.r - a.r) * amount, a.g + (b.g - a.g) * amount, a.b + (b.b - a.b) * amount);
  }

  function luminance(hex) {
    var c = parseHex(hex);
    if (!c) return 255;
    return (c.r * 299 + c.g * 587 + c.b * 114) / 1000;
  }

  function colourFromName(name) {
    var key = normalizeName(name);
    if (FLAVOUR_COLORS[key]) return FLAVOUR_COLORS[key];
    if (/chocolate|choco|fudge/.test(key)) return '#5d3a1a';
    if (/mocha|coffee|cafe/.test(key)) return '#6f4e37';
    if (/ice cream|icecream/.test(key)) return '#fff6e0';
    if (/vanilla|creme|bean/.test(key)) return '#f5e6c8';
    if (/mango/.test(key)) return '#ffb347';
    if (/orange/.test(key)) return '#ff7a00';
    if (/watermelon|melon/.test(key)) return '#e23d4f';
    if (/strawberry/.test(key)) return '#e85d75';
    if (/blueberry|blue razz|blue raspberry/.test(key)) return '#3b82f6';
    if (/apple/.test(key)) return '#7cb342';
    if (/lemon|citrus|lime/.test(key)) return '#f4d03f';
    if (/grape/.test(key)) return '#7e22ce';
    if (/peach/.test(key)) return '#ffb07c';
    if (/pineapple/.test(key)) return '#f5c518';
    if (/cola/.test(key)) return '#3b1f0e';
    if (/mint/.test(key)) return '#2dd4bf';
    if (/peanut/.test(key)) return '#d4a017';
    if (/cookie/.test(key)) return '#e8d5b7';
    if (/guava/.test(key)) return '#ff6b9d';
    if (/berry|razz|raspberry/.test(key)) return '#c026d3';
    if (/punch|tropical|fruit/.test(key)) return '#e11d48';
    if (/unflavour|unflavor/.test(key)) return '#d9d4cc';
    var hash = 0;
    for (var i = 0; i < key.length; i += 1) hash = (hash * 33 + key.charCodeAt(i)) >>> 0;
    return 'hsl(' + (hash % 360) + ' 62% 46%)';
  }

  function flavourDotColor(stored, label) {
    var hex = String(stored || '').trim();
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(hex) && hex.toLowerCase() !== '#ff6633') return hex;
    var parts = String(label || '').split(/\s*[·|,/]\s*/).map(function (part) {
      return part.trim();
    }).filter(Boolean);
    var flavourPart = parts.filter(function (part) { return !isSizeLike(part); })[0] || parts[0] || label;
    if (!String(flavourPart || '').trim()) return '#ff6633';
    return colourFromName(flavourPart);
  }

  function buildFlavourTheme(name, color) {
    var key = normalizeName(name);
    var softPair = FLAVOUR_SOFT[key];
    var accentBase = flavourDotColor(color, name);
    if (String(accentBase).indexOf('hsl') === 0) {
      return {
        accent: accentBase,
        accentStrong: accentBase,
        soft: 'color-mix(in srgb, ' + accentBase + ' 16%, #ffffff)',
        softer: 'color-mix(in srgb, ' + accentBase + ' 8%, #ffffff)',
        border: 'color-mix(in srgb, ' + accentBase + ' 32%, transparent)',
        onAccent: '#ffffff',
        glow: 'color-mix(in srgb, ' + accentBase + ' 28%, transparent)',
      };
    }
    var accent = luminance(accentBase) > 160 ? mixHex(accentBase, '#3a2a1c', 0.42) : accentBase;
    var rgb = parseHex(accent);
    return {
      accent: accent,
      accentStrong: mixHex(accent, '#000000', 0.18),
      soft: softPair ? softPair[0] : mixHex(accentBase, '#ffffff', luminance(accentBase) > 160 ? 0.72 : 0.88),
      softer: softPair ? softPair[1] : mixHex(accentBase, '#ffffff', luminance(accentBase) > 160 ? 0.86 : 0.94),
      border: rgb ? 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 0.32)' : 'rgba(255, 102, 51, 0.28)',
      onAccent: luminance(accent) > 160 ? '#2a2118' : '#ffffff',
      glow: rgb ? 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 0.28)' : 'rgba(255, 102, 51, 0.22)',
    };
  }

  function closeCardMenus() {
    qsa('[data-variant-menu]').forEach(function (menu) {
      menu.hidden = true;
      var card = menu.closest('[data-product-card]');
      if (card) card.classList.remove('is-menu-open');
      var trigger = card && qs('[data-variant-trigger]', card);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function closeAttrMenus(root) {
    qsa('[data-attr-menu]', root || document).forEach(function (menu) {
      menu.hidden = true;
      var trigger = qs('[data-attr-trigger]', menu.parentElement);
      if (trigger) {
        trigger.setAttribute('data-state', 'closed');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function placeCardMenu(trigger, menu) {
    var rect = trigger.getBoundingClientRect();
    var width = Math.max(rect.width, 192);
    var left = rect.left;
    if (left + width > window.innerWidth - 8) left = Math.max(8, window.innerWidth - 8 - width);
    menu.style.top = Math.round(rect.bottom + 6) + 'px';
    menu.style.left = Math.round(left) + 'px';
    menu.style.width = Math.round(width) + 'px';
  }

  function cartCount(n) {
    qsa('[data-cart-count]').forEach(function (node) {
      node.textContent = n > 0 ? String(n) : '';
      node.setAttribute('data-count', String(n || 0));
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        return syncBundleDiscount(cart);
      })
      .then(function (cart) {
        cartCount(cart.item_count || 0);
        renderCart(cart);
        return cart;
      })
      .catch(function () {});
  }

  function renderCart(cart) {
    var list = qs('[data-cart-lines]');
    if (!list) return;
    if (!cart.items || !cart.items.length) {
      list.innerHTML = '<p>Your cart is empty.</p>';
      paintCartTotals(cart);
      return;
    }
    list.innerHTML = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="' + String(item.product_title || '').replace(/"/g, '&quot;') + '">'
          : '<span></span>';
        return (
          '<article class="ms-cart-line">' +
          img +
          '<div><h3>' +
          item.product_title +
          '</h3><p>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '') +
          '</p><div class="ms-cart-line-row"><div class="ms-qty"><button type="button" data-qty-change="' +
          item.key +
          '" data-qty="' +
          (item.quantity - 1) +
          '">−</button><span>' +
          item.quantity +
          '</span><button type="button" data-qty-change="' +
          item.key +
          '" data-qty="' +
          (item.quantity + 1) +
          '">+</button></div><button type="button" class="ms-cart-remove" data-qty-change="' +
          item.key +
          '" data-qty="0" aria-label="Remove ' +
          String(item.product_title || 'item').replace(/"/g, '') +
          '">Remove</button><strong>' +
          formatMoney(item.original_line_price != null ? item.original_line_price : item.final_line_price) +
          '</strong></div></div></article>'
        );
      })
      .join('');
    paintCartTotals(cart);
  }

  function discountLabel(cart) {
    var titles = [];
    function push(title) {
      if (String(title || '').toUpperCase() === 'BUNDLE5') title = 'Bundle discount (5%)';
      if (!title || titles.indexOf(title) !== -1) return;
      titles.push(title);
    }
    (cart.cart_level_discount_applications || []).forEach(function (entry) {
      push(entry.title);
    });
    (cart.items || []).forEach(function (item) {
      (item.discounts || []).forEach(function (entry) {
        push(entry.title);
      });
    });
    if (!titles.length) {
      (cart.discount_codes || []).forEach(function (entry) {
        if (entry.applicable) push(entry.code);
      });
    }
    return titles.join(' · ') || 'Discount';
  }

  function paintCartTotals(cart) {
    var discount = cart.total_discount || 0;
    var itemsTotal = qs('[data-cart-items-total]');
    var discountRow = qs('[data-cart-discount]');
    var sub = qs('[data-cart-subtotal]');
    if (itemsTotal) {
      itemsTotal.style.display = discount <= 0 ? 'none' : '';
      var itemsAmount = qs('[data-cart-items-amount]');
      if (itemsAmount) itemsAmount.textContent = formatMoney(cart.original_total_price || 0);
    }
    if (discountRow) {
      discountRow.style.display = discount <= 0 ? 'none' : '';
      var label = qs('[data-cart-discount-label]');
      var amount = qs('[data-cart-discount-amount]');
      if (label) label.textContent = discountLabel(cart);
      if (amount) amount.textContent = '−' + formatMoney(discount);
    }
    if (sub) sub.textContent = formatMoney(cart.total_price || 0);
  }

  function discountCodeApplied(cart, code) {
    var wanted = String(code || '').toUpperCase();
    return (cart.discount_codes || []).some(function (entry) {
      return String(entry.code || '').toUpperCase() === wanted && entry.applicable;
    });
  }

  function updateDiscountCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: codes.filter(Boolean).join(',') }),
    }).then(function (res) {
      if (!res.ok) throw new Error('discount failed');
      return res.json();
    });
  }

  function applyDiscountCookie(code) {
    return fetch('/discount/' + encodeURIComponent(code), {
      credentials: 'same-origin',
      redirect: 'manual',
    }).then(function () {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) { return res.json(); });
    });
  }

  function clearBundleDiscountCookie() {
    document.cookie = 'discount_code=; Max-Age=0; path=/';
  }

  function syncBundleDiscount(cart) {
    var entry = (cart.discount_codes || []).filter(function (code) {
      return String(code.code || '').toUpperCase() === 'BUNDLE5';
    })[0];
    if (!entry || entry.applicable) return Promise.resolve(cart);
    clearBundleDiscountCookie();
    var codes = (cart.discount_codes || [])
      .map(function (code) { return code.code; })
      .filter(function (code) { return String(code).toUpperCase() !== 'BUNDLE5'; });
    return updateDiscountCodes(codes).catch(function () { return cart; });
  }

  function applyDiscountCode(code) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var original = cart.original_total_price || 0;
        var rate = original > 0 ? (cart.total_discount || 0) / original : 0;
        var betterDiscount = (cart.discount_codes || []).some(function (entry) {
          return entry.applicable && String(entry.code || '').toUpperCase() !== String(code).toUpperCase();
        });
        if (betterDiscount && rate >= 0.05) return { cart: cart, skip: true };
        var codes = (cart.discount_codes || [])
          .map(function (entry) { return entry.code; })
          .filter(function (existing) {
            return existing && String(existing).toUpperCase() !== String(code).toUpperCase();
          });
        codes.push(code);
        return updateDiscountCodes(codes).catch(function () { return cart; }).then(function (next) {
          return { cart: next, skip: false };
        });
      })
      .then(function (result) {
        if (result.skip) return result.cart;
        return applyDiscountCookie(code);
      });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function () {
      return refreshCart();
    });
  }

  function shiprocketBuyDirect(id, quantity) {
    var events = window.shiprocketCheckoutEvents;
    if (!window.MuscleSmith || !window.MuscleSmith.shiprocket) return false;
    if (!events || typeof events.buyDirect !== 'function') return false;
    try {
      events.buyDirect({
        type: 'product',
        products: [{ variantId: Number(id), quantity: quantity || 1 }],
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  function addVariant(id, quantity, thenCheckout) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] }),
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      if (thenCheckout) {
        if (window.MuscleSmith && window.MuscleSmith.shiprocket) {
          return refreshCart().then(function () {
            openCart();
          });
        }
        window.location.href = '/checkout';
        return;
      }
      return refreshCart().then(function () {
        openCart();
      });
    });
  }

  function addStack(ids) {
    var items = ids
      .map(function (id) { return { id: Number(id), quantity: 1 }; })
      .filter(function (item) { return item.id > 0; });
    if (!items.length) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return refreshCart().then(function () {
        openCart();
      });
    });
  }

  var cartDrawer = qs('[data-cart-drawer]');
  var menuDrawer = qs('[data-mobile-menu]');
  var searchOverlay = qs('[data-search-overlay]');

  function openCart() {
    if (cartDrawer) cartDrawer.hidden = false;
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.hidden = true;
  }
  function openMenu() {
    if (!menuDrawer) return;
    menuDrawer.hidden = false;
    var sheet = qs('.ms-mobile-drawer', menuDrawer);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        menuDrawer.classList.add('is-open');
        if (sheet) sheet.classList.add('is-open');
      });
    });
  }
  function closeMenu() {
    if (!menuDrawer) return;
    menuDrawer.classList.remove('is-open');
    var sheet = qs('.ms-mobile-drawer', menuDrawer);
    if (sheet) sheet.classList.remove('is-open');
    window.setTimeout(function () {
      if (!menuDrawer.classList.contains('is-open')) menuDrawer.hidden = true;
    }, 440);
  }

  qsa('[data-open-cart]').forEach(function (btn) {
    on(btn, 'click', function (event) {
      event.preventDefault();
      openCart();
      refreshCart();
    });
  });
  qsa('[data-close-cart]').forEach(function (btn) {
    on(btn, 'click', closeCart);
  });
  qsa('[data-open-menu]').forEach(function (btn) {
    on(btn, 'click', openMenu);
  });
  qsa('[data-close-menu]').forEach(function (btn) {
    on(btn, 'click', closeMenu);
  });
  qsa('[data-open-search]').forEach(function (btn) {
    on(btn, 'click', function () {
      if (!searchOverlay) return;
      searchOverlay.classList.toggle('is-open');
      var input = qs('input', searchOverlay);
      if (input && searchOverlay.classList.contains('is-open')) input.focus();
    });
  });

  on(document, 'click', function (event) {
    var qtyBtn = event.target.closest('[data-qty-change]');
    if (qtyBtn) {
      changeLine(qtyBtn.getAttribute('data-qty-change'), Number(qtyBtn.getAttribute('data-qty')));
    }
    var add = event.target.closest('[data-add-variant]');
    if (add) {
      event.preventDefault();
      event.stopPropagation();
      var card = add.closest('[data-product-card]');
      var id = card ? card.getAttribute('data-variant-id') : add.getAttribute('data-add-variant');
      var buyNow = add.hasAttribute('data-buy-now');
      if (id && !(buyNow && shiprocketBuyDirect(id, 1))) addVariant(id, 1, buyNow);
    }
    var stackBtn = event.target.closest('[data-add-stack]');
    if (stackBtn && !stackBtn.disabled) {
      event.preventDefault();
      stackBtn.disabled = true;
      addStack((stackBtn.getAttribute('data-add-stack') || '').split(','))
        .catch(function () {})
        .then(function () {
          stackBtn.disabled = false;
        });
    }
  });

  /* Deal countdowns */
  qsa('[data-countdown]').forEach(function (node) {
    var raw = node.getAttribute('data-countdown') || '';
    var end = new Date(raw.indexOf('T') === -1 ? raw + 'T23:59:59' : raw).getTime();
    if (!end || isNaN(end)) return;
    var section = node.closest('[data-countdown-hide]');
    var units = {};
    qsa('[data-countdown-unit]', node).forEach(function (unit) {
      units[unit.getAttribute('data-countdown-unit')] = unit;
    });
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }
    var timer;
    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (!left) {
        window.clearInterval(timer);
        node.hidden = true;
        if (section) section.hidden = true;
        return;
      }
      node.hidden = false;
      if (units.d) units.d.textContent = pad(Math.floor(left / 86400));
      if (units.h) units.h.textContent = pad(Math.floor((left % 86400) / 3600));
      if (units.m) units.m.textContent = pad(Math.floor((left % 3600) / 60));
      if (units.s) units.s.textContent = pad(left % 60);
    }
    tick();
    timer = window.setInterval(tick, 1000);
  });

  /* Hero carousel */
  qsa('[data-hero]').forEach(function (hero) {
    var slides = qsa('[data-hero-slide]', hero);
    if (slides.length < 2) return;
    var index = 0;
    var timer;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.hidden = i !== index;
      });
      qsa('[data-hero-dot]', hero).forEach(function (dot, i) {
        dot.setAttribute('data-active', i === index ? 'true' : 'false');
      });
    }
    function start() {
      window.clearInterval(timer);
      timer = window.setInterval(function () {
        show(index + 1);
      }, 5000);
    }
    qsa('[data-hero-prev]', hero).forEach(function (btn) {
      on(btn, 'click', function () {
        show(index - 1);
        start();
      });
    });
    qsa('[data-hero-next]', hero).forEach(function (btn) {
      on(btn, 'click', function () {
        show(index + 1);
        start();
      });
    });
    qsa('[data-hero-dot]', hero).forEach(function (dot) {
      on(dot, 'click', function () {
        show(Number(dot.getAttribute('data-hero-dot')));
        start();
      });
    });
    var startX = 0;
    var startY = 0;
    var tracking = false;
    var swiped = false;
    hero.addEventListener('touchstart', function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) return;
      startX = event.changedTouches[0].clientX;
      startY = event.changedTouches[0].clientY;
      tracking = true;
      swiped = false;
    }, { passive: true });
    hero.addEventListener('touchend', function (event) {
      if (!tracking || !event.changedTouches || !event.changedTouches[0]) return;
      tracking = false;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy)) return;
      swiped = true;
      show(index + (dx < 0 ? 1 : -1));
      start();
    }, { passive: true });
    hero.addEventListener('click', function (event) {
      if (!swiped) return;
      event.preventDefault();
      event.stopPropagation();
      swiped = false;
    }, true);
    show(0);
    start();
  });

  /* Infinite marquees: repeat one sequence until the strip always covers the viewport. */
  function loopMarquee(container, track, unitSelector) {
    if (!container || !track) return;
    var source = qs(unitSelector, track);
    if (!source) return;
    var lastWidth = 0;
    var lastCount = 0;

    function fill() {
      var width = source.getBoundingClientRect().width;
      var viewport = container.clientWidth;
      if (!width || !viewport) return;
      var needed = Math.max(2, Math.ceil(viewport / width) + 1);
      if (needed === lastCount && Math.abs(width - lastWidth) < 0.5) return;
      while (track.children.length > 1) track.removeChild(track.lastElementChild);
      for (var n = 1; n < needed; n++) track.appendChild(source.cloneNode(true));
      track.style.setProperty('--ms-loop-shift', width + 'px');
      lastWidth = width;
      lastCount = needed;
    }

    fill();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fill);
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(fill);
      observer.observe(container);
    } else {
      on(window, 'resize', fill);
    }
  }

  qsa('.ms-ticker').forEach(function (ticker) {
    var track = qs('.ms-ticker-track', ticker);
    loopMarquee(ticker, track, '.ms-ticker-list');
    if (!track) return;
    on(ticker, 'mouseenter', function () {
      track.style.animationPlayState = 'paused';
    });
    on(ticker, 'mouseleave', function () {
      track.style.animationPlayState = 'running';
    });
  });

  qsa('.dw-marquee').forEach(function (marquee) {
    loopMarquee(marquee, qs('.dw-marquee-track', marquee), '.dw-marquee-seq');
  });

  /* Category rails */
  qsa('[data-rail]').forEach(function (rail) {
    var scroller = qs('[data-rail-scroll]', rail);
    if (!scroller) return;
    function markScrollable() {
      rail.classList.toggle('is-scrollable', scroller.scrollWidth - scroller.clientWidth > 8);
    }
    markScrollable();
    window.addEventListener('resize', markScrollable);
    qsa('[data-rail-dir]', rail).forEach(function (btn) {
      on(btn, 'click', function () {
        var dir = Number(btn.getAttribute('data-rail-dir'));
        scroller.scrollBy({ left: dir * Math.max(scroller.clientWidth * 0.75, 220), behavior: 'smooth' });
      });
    });
  });

  /* Bestseller chips */
  qsa('[data-filter-row]').forEach(function (row) {
    var grid = qs('#' + row.getAttribute('data-filter-row'));
    if (!grid) return;
    qsa('[data-filter]', row).forEach(function (chip) {
      on(chip, 'click', function () {
        var id = chip.getAttribute('data-filter');
        qsa('[data-filter]', row).forEach(function (other) {
          other.setAttribute('data-active', other === chip ? 'true' : 'false');
        });
        qsa('[data-filter-item]', grid).forEach(function (card) {
          var keys = (card.getAttribute('data-filter-item') || '').split(',');
          card.classList.toggle('ms-hidden', id !== 'all' && keys.indexOf(id) === -1);
        });
      });
    });
  });

  qsa('[data-catalog-sort]').forEach(function (select) {
    on(select, 'change', function () {
      if (select.form) select.form.submit();
    });
  });

  function focusCatalogChip(chip, smooth) {
    if (!chip) return;
    var row = chip.closest('.ms-chip-row');
    if (!row) return;
    var rowRect = row.getBoundingClientRect();
    var chipRect = chip.getBoundingClientRect();
    var left = row.scrollLeft + (chipRect.left - rowRect.left) - (row.clientWidth - chipRect.width) / 2;
    row.scrollTo({ left: Math.max(0, left), behavior: smooth ? 'smooth' : 'auto' });
  }

  (function () {
    var lanes = qsa('.ms-catalog-lane');
    var chips = qsa('[data-lane-link]');
    var currentId = '';
    function activateLane(id, smooth) {
      if (!id || id === currentId) return;
      currentId = id;
      var activeChip = null;
      chips.forEach(function (chip) {
        var active = chip.getAttribute('href') === '#' + id;
        if (active) {
          chip.setAttribute('data-active', 'true');
          activeChip = chip;
        } else {
          chip.removeAttribute('data-active');
        }
      });
      qsa('.ms-catalog-chips .ms-chip[href="#ms-catalog-groups"]').forEach(function (all) {
        all.removeAttribute('data-active');
      });
      focusCatalogChip(activeChip, smooth);
    }
    if (lanes.length && chips.length && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activateLane(entry.target.id, true);
        });
      }, { rootMargin: '-40% 0px -45% 0px', threshold: 0 });
      lanes.forEach(function (lane) { obs.observe(lane); });
    }
    requestAnimationFrame(function () {
      focusCatalogChip(qs('.ms-catalog-chips .ms-chip[data-active="true"]'), false);
    });
  })();

  /* Collection search */
  qsa('[data-collection-search]').forEach(function (input) {
    on(input, 'input', function () {
      var q = input.value.trim().toLowerCase();
      var grid = qs('#' + input.getAttribute('data-collection-search'));
      if (!grid) return;
      qsa('[data-product-card]', grid).forEach(function (card) {
        var name = (card.getAttribute('data-name') || '').toLowerCase();
        card.classList.toggle('ms-hidden', q && name.indexOf(q) === -1);
      });
    });
  });

  /* Card variant menus */
  qsa('[data-product-card]').forEach(function (card) {
    var raw = qs('[data-variants]', card);
    if (!raw) return;
    var variants = [];
    try {
      variants = JSON.parse(raw.textContent || '[]');
    } catch (e) {
      variants = [];
    }
    var trigger = qs('[data-variant-trigger]', card);
    var menu = qs('[data-variant-menu]', card);
    function apply(variant) {
      if (!variant) return;
      card.setAttribute('data-variant-id', String(variant.id));
      var label = qs('[data-variant-label]', card);
      if (label) label.textContent = variant.title;
      var price = qs('[data-price]', card);
      if (price) price.textContent = formatMoney(variant.price);
      var mrp = qs('[data-mrp]', card);
      if (mrp) {
        if (variant.compare && variant.compare > variant.price) {
          mrp.textContent = formatMoney(variant.compare);
          mrp.hidden = false;
        } else {
          mrp.hidden = true;
        }
      }
      var perServing = qs('[data-per-serving]', card);
      if (perServing) {
        var perText = variant.servings > 0 ? perServingText(variant.price, variant.servings) : '';
        perServing.hidden = !perText;
        if (perText) perServing.textContent = perText;
      }
      var save = qs('[data-save]', card);
      if (save) {
        var saving = variant.compare > variant.price ? variant.compare - variant.price : 0;
        save.textContent = saving ? 'Save ' + formatMoney(saving) : '';
        save.hidden = !saving;
      }
      var stockLabel = qs('[data-low-stock-label]', card);
      if (stockLabel) {
        var limit = Number(card.getAttribute('data-low-stock')) || 0;
        var left = variant.inventory;
        var isLow = limit > 0 && typeof left === 'number' && left > 0 && left <= limit;
        stockLabel.textContent = isLow ? 'Only ' + left + ' left' : '';
        stockLabel.hidden = !isLow;
      }
      var img = qs('.ms-bundle-card-img', card);
      if (img && variant.image) {
        img.src = variant.image;
        img.classList.remove('ms-bundle-card-logo');
      }
      var triggerDot = trigger ? qs('.ms-bundle-dot', trigger) : qs('.ms-bundle-dot', card);
      if (triggerDot) triggerDot.style.backgroundColor = flavourDotColor(variant.color, variant.title);
      card.classList.toggle('is-sold-out', !variant.available);
      if (menu) {
        qsa('[data-variant-option]', menu).forEach(function (option) {
          var active = Number(option.getAttribute('data-variant-option')) === variant.id;
          option.setAttribute('data-active', active ? 'true' : 'false');
          option.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
    }
    if (menu) {
      qsa('[data-variant-option]', menu).forEach(function (option) {
        var id = Number(option.getAttribute('data-variant-option'));
        var row = variants.filter(function (item) { return item.id === id; })[0];
        var dot = qs('.ms-bundle-dot', option);
        if (dot && row) dot.style.backgroundColor = flavourDotColor(row.color, row.title);
        on(option, 'click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          apply(row);
          menu.hidden = true;
          card.classList.remove('is-menu-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
      });
    }
    if (trigger && menu) {
      on(trigger, 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var open = menu.hidden;
        closeCardMenus();
        if (open) {
          placeCardMenu(trigger, menu);
          menu.hidden = false;
          card.classList.add('is-menu-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    }
    var currentId = Number(card.getAttribute('data-variant-id'));
    apply(variants.filter(function (row) { return row.id === currentId; })[0] || variants[0]);
  });

  on(document, 'click', function () {
    closeCardMenus();
    closeAttrMenus();
  });
  on(window, 'resize', closeCardMenus);
  window.addEventListener('scroll', closeCardMenus, true);

  /* Product page */
  var productRoot = qs('[data-product-root]');
  if (productRoot) {
    var dataNode = qs('[data-product-json]', productRoot);
    var productData = { variants: [], flavourColors: {} };
    try {
      productData = JSON.parse(dataNode.textContent || '{}');
    } catch (e) {}
    var variantInput = qs('[name="id"]', productRoot);
    var qtyInput = qs('[data-qty-value]', productRoot);
    var selection = {};

    function currentVariant() {
      var options = (productData.options || []).map(function (name) {
        return selection[name];
      });
      return (productData.variants || []).filter(function (variant) {
        return (variant.options || []).every(function (value, index) {
          return !options[index] || value === options[index];
        });
      })[0];
    }

    function storedFlavourColor(name) {
      var colors = productData.flavourColors;
      if (!colors) return null;
      if (Array.isArray(colors)) {
        var match = colors.filter(function (row) {
          return row && normalizeName(row.name || row.label) === normalizeName(name);
        })[0];
        return match ? match.color || match.hex || match.value : null;
      }
      if (typeof colors !== 'object') return null;
      if (colors[name]) return colors[name];
      var key = String(name || '').toLowerCase();
      if (colors[key]) return colors[key];
      var found = null;
      Object.keys(colors).forEach(function (item) {
        if (String(item).toLowerCase() === key) found = colors[item];
      });
      return found;
    }

    function applyTheme(name) {
      if (!name || isSizeLike(name)) return;
      var theme = buildFlavourTheme(name, storedFlavourColor(name));
      productRoot.style.setProperty('--dw-accent', theme.accent);
      productRoot.style.setProperty('--dw-accent-strong', theme.accentStrong);
      productRoot.style.setProperty('--dw-soft', theme.soft);
      productRoot.style.setProperty('--dw-softer', theme.softer);
      productRoot.style.setProperty('--dw-border', theme.border);
      productRoot.style.setProperty('--dw-on-accent', theme.onAccent);
      productRoot.style.setProperty('--dw-glow', theme.glow);
    }

    function flavourValue(variant) {
      var options = productData.options || [];
      var index = 0;
      options.forEach(function (name, i) {
        if (/flavour|flavor|colour|color|taste/i.test(name)) index = i;
      });
      var value = variant && variant.options ? variant.options[index] : '';
      if (value && !isSizeLike(value)) return value;
      return (variant && variant.options ? variant.options : []).filter(function (item) {
        return item && !isSizeLike(item);
      })[0] || value;
    }

    function syncPickers() {
      qsa('[data-option]', productRoot).forEach(function (peer) {
        var selected = selection[peer.getAttribute('data-option-name')] === peer.getAttribute('data-option');
        peer.classList.toggle('is-selected', selected);
        if (peer.hasAttribute('aria-selected')) peer.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      qsa('.dw-attr', productRoot).forEach(function (attr) {
        var current = qs('[data-option-current]', attr);
        var value = current ? current.textContent : '';
        var media = qs('.dw-attr-trigger-media', attr);
        var selected = qsa('[data-option]', attr).filter(function (button) {
          return button.getAttribute('data-option') === value;
        })[0];
        var image = selected && qs('img', selected);
        if (media) {
          if (image) {
            media.innerHTML = '<img src="' + image.getAttribute('src') + '" alt="' + (image.getAttribute('alt') || '') + '">';
          } else {
            media.innerHTML = '<span class="dw-attr-colour" data-attr-swatch aria-hidden="true"></span>';
            var swatch = qs('[data-attr-swatch]', media);
            if (swatch) swatch.style.backgroundColor = flavourDotColor(storedFlavourColor(value), value);
          }
        }
        qsa('[data-option-swatch]', attr).forEach(function (dot) {
          var optionValue = dot.closest('[data-option]').getAttribute('data-option');
          dot.style.backgroundColor = flavourDotColor(storedFlavourColor(optionValue), optionValue);
        });
      });
      qsa('.dw-flavour-card', productRoot).forEach(function (card) {
        var optionValue = card.getAttribute('data-option');
        var swatch = qs('.dw-flavour-card-swatch', card);
        if (swatch) swatch.style.backgroundColor = flavourDotColor(storedFlavourColor(optionValue), optionValue);
      });
    }

    function paint(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      var price = qs('[data-product-price]', productRoot);
      if (price) price.textContent = formatMoney(variant.price);
      var perServing = qs('[data-product-per-serving]', productRoot);
      if (perServing) {
        var perText = variant.servings > 0 ? perServingText(variant.price, variant.servings) : '';
        perServing.hidden = !perText;
        perServing.textContent = perText;
      }
      var mrp = qs('[data-product-mrp]', productRoot);
      var save = qs('[data-product-save]', productRoot);
      var onSale = variant.compare && variant.compare > variant.price;
      if (mrp) {
        mrp.hidden = !onSale;
        if (onSale) mrp.textContent = formatMoney(variant.compare);
      }
      if (save) {
        save.hidden = !onSale;
        if (onSale) {
          save.textContent = Math.round(((variant.compare - variant.price) * 100) / variant.compare) + '% off';
        }
      }
      qsa('[data-product-image]', productRoot).forEach(function (img) {
        if (variant.image) img.src = variant.image;
      });
      qsa('[data-sticky-price]', productRoot).forEach(function (node) {
        node.textContent = formatMoney(variant.price);
      });
      var sold = !variant.available;
      var actions = qs('[data-product-actions]', productRoot);
      if (actions) actions.classList.toggle('is-sold-out', sold);
      qsa('[data-when-available]', productRoot).forEach(function (node) {
        node.hidden = sold;
      });
      qsa('[data-when-unavailable]', productRoot).forEach(function (node) {
        node.hidden = !sold;
      });
      qsa('[data-product-cta]', productRoot).forEach(function (btn) {
        btn.disabled = sold;
      });
      var mobileBuy = qs('[data-mobile-buy]');
      var mobileLabel = qs('[data-mobile-buy-label]');
      if (mobileLabel) mobileLabel.textContent = sold ? 'Show interest' : 'Buy Now';
      if (mobileBuy) {
        if (sold) {
          mobileBuy.setAttribute('data-open-interest', '');
          mobileBuy.removeAttribute('data-buy');
          mobileBuy.removeAttribute('data-checkout');
        } else {
          mobileBuy.removeAttribute('data-open-interest');
          mobileBuy.setAttribute('data-buy', '');
          mobileBuy.setAttribute('data-checkout', '');
        }
      }
      var interestVariant = qs('[data-interest-variant-field]', productRoot);
      var interestVariantLabel = qs('[data-interest-variant-label]', productRoot);
      var variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';
      if (interestVariant) interestVariant.value = variantTitle;
      if (interestVariantLabel) interestVariantLabel.textContent = variantTitle ? ' (' + variantTitle + ')' : '';
      qsa('.shiprocket-headless[data-type="product"]', productRoot).forEach(function (node) {
        node.classList.toggle('is-disabled', sold);
      });
      applyTheme(flavourValue(variant));
      syncPickers();
    }

    qsa('[data-attr-trigger]', productRoot).forEach(function (trigger) {
      on(trigger, 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var menu = qs('[data-attr-menu]', trigger.parentElement);
        var open = menu && menu.hidden;
        closeAttrMenus(productRoot);
        if (menu && open) {
          menu.hidden = false;
          trigger.setAttribute('data-state', 'open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    qsa('[data-option]', productRoot).forEach(function (button) {
      on(button, 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var name = button.getAttribute('data-option-name');
        var value = button.getAttribute('data-option');
        selection[name] = value;
        qsa('[data-option-name="' + name + '"]', productRoot).forEach(function (peer) {
          var selected = peer.getAttribute('data-option') === value;
          peer.classList.toggle('is-selected', selected);
          peer.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
        qsa('[data-option-current]', productRoot).forEach(function (label) {
          if (label.getAttribute('data-option-current') === name) label.textContent = value;
        });
        closeAttrMenus(productRoot);
        paint(currentVariant());
      });
    });

    function paintQty(next) {
      if (!qtyInput) return;
      qtyInput.value = String(next);
      var shown = qs('[data-qty-label]', productRoot);
      if (shown) shown.textContent = String(next);
      qsa('[data-qty-step="-1"]', productRoot).forEach(function (btn) {
        btn.disabled = next <= 1;
      });
      qsa('[data-qty-step="1"]', productRoot).forEach(function (btn) {
        btn.disabled = next >= 99;
      });
    }

    qsa('[data-qty-step]', productRoot).forEach(function (btn) {
      on(btn, 'click', function () {
        var next = Math.max(1, Math.min(99, Number(qtyInput.value || 1) + Number(btn.getAttribute('data-qty-step'))));
        paintQty(next);
      });
    });
    paintQty(1);

    function showGallery(thumb) {
      if (!thumb) return;
      var src = thumb.getAttribute('data-thumb');
      qsa('[data-gallery-image]', productRoot).forEach(function (img) {
        img.src = src;
      });
      qsa('[data-thumb]', productRoot).forEach(function (peer) {
        peer.classList.toggle('is-active', peer === thumb);
      });
    }

    function stepGallery(dir) {
      var thumbs = qsa('[data-thumb]', productRoot);
      if (thumbs.length < 2) return;
      var active = 0;
      thumbs.forEach(function (thumb, index) {
        if (thumb.classList.contains('is-active')) active = index;
      });
      var next = thumbs[active + dir];
      if (!next) next = dir > 0 ? thumbs[0] : thumbs[thumbs.length - 1];
      showGallery(next);
    }

    qsa('[data-thumb]', productRoot).forEach(function (thumb) {
      on(thumb, 'click', function () {
        showGallery(thumb);
      });
    });
    qsa('[data-gallery-prev]', productRoot).forEach(function (btn) {
      on(btn, 'click', function () {
        stepGallery(-1);
      });
    });
    qsa('[data-gallery-next]', productRoot).forEach(function (btn) {
      on(btn, 'click', function () {
        stepGallery(1);
      });
    });

    var stage = qs('[data-gallery-stage]', productRoot);
    if (stage) {
      var galleryX = 0;
      var galleryY = 0;
      stage.addEventListener('touchstart', function (event) {
        if (!event.changedTouches || !event.changedTouches[0]) return;
        galleryX = event.changedTouches[0].clientX;
        galleryY = event.changedTouches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (!event.changedTouches || !event.changedTouches[0]) return;
        var dx = event.changedTouches[0].clientX - galleryX;
        var dy = event.changedTouches[0].clientY - galleryY;
        if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy)) return;
        stepGallery(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    qsa('[data-tab]', productRoot).forEach(function (tab) {
      on(tab, 'click', function () {
        var id = tab.getAttribute('data-tab');
        qsa('[data-tab]', productRoot).forEach(function (peer) {
          peer.setAttribute('data-state', peer === tab ? 'active' : '');
        });
        qsa('[data-tab-panel]', productRoot).forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-tab-panel') !== id;
        });
      });
    });

    function shiprocketButton() {
      return document.querySelector('.shiprocket-headless[data-type="product"] .sr-headless-checkout, button.sr-headless-checkout');
    }

    var interestDialog = qs('[data-interest-dialog]', productRoot);

    function openInterest() {
      if (!interestDialog) return;
      var variant = currentVariant();
      var variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
      var variantField = qs('[data-interest-variant-field]', interestDialog);
      var variantLabel = qs('[data-interest-variant-label]', interestDialog);
      if (variantField) variantField.value = variantTitle;
      if (variantLabel) variantLabel.textContent = variantTitle ? ' (' + variantTitle + ')' : '';
      if (typeof interestDialog.showModal === 'function' && !interestDialog.open) interestDialog.showModal();
    }

    function closeInterest() {
      if (interestDialog && interestDialog.open) interestDialog.close();
    }

    qsa('[data-open-interest]').forEach(function (btn) {
      on(btn, 'click', function (event) {
        event.preventDefault();
        openInterest();
      });
    });

    on(document, 'click', function (event) {
      var opener = event.target && event.target.closest ? event.target.closest('[data-open-interest]') : null;
      if (!opener || opener.closest('[data-product-root]')) return;
      event.preventDefault();
      openInterest();
    });

    if (interestDialog) {
      on(qs('[data-interest-close]', interestDialog), 'click', closeInterest);
      interestDialog.addEventListener('click', function (event) {
        if (event.target.closest('[data-interest-close]')) {
          closeInterest();
          return;
        }
        var rect = interestDialog.getBoundingClientRect();
        var inside = rect.top <= event.clientY && event.clientY <= rect.bottom && rect.left <= event.clientX && event.clientX <= rect.right;
        if (!inside) closeInterest();
      });
      var interestForm = qs('#ms-interest-form', interestDialog);
      on(interestForm, 'submit', function () {
        var nameInput = qs('[name="contact[name]"]', interestForm);
        var phoneInput = qs('[name="contact[phone]"]', interestForm);
        var emailInput = qs('[name="contact[email]"]', interestForm);
        var productField = qs('[data-interest-product-field]', interestForm);
        var variantField = qs('[data-interest-variant-field]', interestForm);
        var urlField = qs('[data-interest-url]', interestForm);
        var body = qs('[data-interest-body]', interestForm);
        if (body) {
          body.value = [
            'Show interest — please contact this customer when the product is back in stock.',
            '',
            'Product: ' + ((productField && productField.value) || ''),
            (variantField && variantField.value) ? 'Option: ' + variantField.value : '',
            'Name: ' + ((nameInput && nameInput.value) || '').trim(),
            'Phone: ' + ((phoneInput && phoneInput.value) || '').trim(),
            'Email: ' + ((emailInput && emailInput.value) || '').trim(),
            (urlField && urlField.value) ? 'Page: ' + urlField.value : ''
          ].filter(function (line) { return line !== ''; }).join('\n');
        }
        try { sessionStorage.setItem('ms-interest-pending', '1'); } catch (e) {}
      });
    }

    var postedHash = (window.location.hash || '').replace('#', '');
    var interestPending = false;
    try { interestPending = sessionStorage.getItem('ms-interest-pending') === '1'; } catch (e) {}
    if (interestPending) {
      try { sessionStorage.removeItem('ms-interest-pending'); } catch (e) {}
    }
    var hasPosted = !!qs('[data-posted-for]', productRoot);
    if (hasPosted && (!postedHash || postedHash === 'contact_form')) {
      postedHash = interestPending ? 'ms-interest-form' : 'ms-review-form';
    }
    qsa('[data-posted-for]', productRoot).forEach(function (node) {
      node.hidden = node.getAttribute('data-posted-for') !== postedHash;
    });
    if (postedHash === 'ms-review-form') {
      var review = qs('#write-review', productRoot);
      if (review && review.scrollIntoView) review.scrollIntoView();
    }
    if (interestDialog && postedHash === 'ms-interest-form' && hasPosted) {
      var interestSuccess = qs('[data-posted-for="ms-interest-form"].ms-success', interestDialog);
      if (interestSuccess && !interestSuccess.hidden) {
        var fields = qs('[data-interest-fields]', interestDialog);
        if (fields) fields.hidden = true;
      }
      openInterest();
    }

    qsa('[data-buy]').forEach(function (btn) {
      on(btn, 'click', function () {
        var variant = currentVariant();
        if (!variant || !variant.available) return;
        if (btn.hasAttribute('data-checkout') && window.MuscleSmith && window.MuscleSmith.shiprocket) {
          var sr = shiprocketButton();
          if (sr) {
            sr.click();
            return;
          }
        }
        addVariant(variant.id, Number(qtyInput && qtyInput.value) || 1, btn.hasAttribute('data-checkout'));
      });
    });

    var first = (productData.variants || []).filter(function (variant) {
      return variant.available;
    })[0] || (productData.variants || [])[0];
    if (first) {
      (productData.options || []).forEach(function (name, index) {
        selection[name] = first.options[index];
      });
      paint(first);
    }

    var bar = qs('.dw-desktop-bar', productRoot);
    var buyBox = qs('.dw-actions', productRoot);
    if (bar && buyBox && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var visible = entries[0] && entries[0].isIntersecting;
        bar.hidden = visible;
      });
      observer.observe(buyBox);
    }
  }

  /* Bundle builder */
  qsa('[data-bundle]').forEach(function (bundle) {
    var raw = qs('[data-bundle-json]', bundle);
    var catalog = { items: [] };
    try {
      catalog = JSON.parse(raw.textContent || '{}');
    } catch (e) {}
    var byKey = {};
    (catalog.items || []).forEach(function (item) {
      byKey[String(item.key)] = item;
    });
    var rate = Number(bundle.getAttribute('data-discount') || 5) / 100;
    var minItems = Number(bundle.getAttribute('data-min') || 2);
    var lines = {};
    var checkIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (ch) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
      });
    }

    function variantFor(key) {
      var item = byKey[key];
      var line = lines[key];
      if (!item || !line) return null;
      return (item.variants || []).filter(function (variant) {
        return variant.id === line.variantId;
      })[0] || (item.variants || [])[0];
    }

    qsa('[data-bundle-card]', bundle).forEach(function (card) {
      var key = card.getAttribute('data-key');
      var select = qs('[data-bundle-variant]', card);
      var item = byKey[key];
      lines[key] = {
        selected: card.getAttribute('data-selected') === 'true',
        qty: 1,
        variantId: select ? Number(select.value) : item && item.variants[0] && item.variants[0].id,
      };
      on(qs('[data-bundle-toggle]', card), 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        lines[key].selected = !lines[key].selected;
        paintBundle();
      });
      on(card, 'click', function (event) {
        if (event.target.closest('select, button, .dw-bundle-qty, .dw-bundle-picker')) return;
        lines[key].selected = !lines[key].selected;
        paintBundle();
      });
      if (select) {
        on(select, 'change', function () {
          lines[key].variantId = Number(select.value);
          lines[key].selected = true;
          paintBundle();
        });
      }
      qsa('[data-bundle-qty]', card).forEach(function (btn) {
        on(btn, 'click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          lines[key].qty = Math.max(1, Math.min(99, lines[key].qty + Number(btn.getAttribute('data-bundle-qty'))));
          lines[key].selected = true;
          paintBundle();
        });
      });
    });

    function paintBundle() {
      var selected = [];
      var subtotal = 0;
      qsa('[data-bundle-card]', bundle).forEach(function (card) {
        var key = card.getAttribute('data-key');
        var line = lines[key];
        var variant = variantFor(key);
        var item = byKey[key];
        card.classList.toggle('is-selected', line.selected);
        var toggle = qs('[data-bundle-toggle]', card);
        if (toggle) {
          toggle.setAttribute('aria-pressed', line.selected ? 'true' : 'false');
          toggle.innerHTML = line.selected ? checkIcon : '';
          toggle.setAttribute('aria-label', (line.selected ? 'Remove ' : 'Add ') + (item ? item.title : 'product') + (line.selected ? ' from bundle' : ' to bundle'));
        }
        var price = qs('[data-bundle-price]', card);
        if (price && variant) price.textContent = formatMoney(variant.price);
        var image = qs('[data-bundle-image]', card);
        if (image && variant && variant.image) image.src = variant.image;
        var qtyLabel = qs('[data-bundle-qty-label]', card);
        if (qtyLabel) qtyLabel.textContent = String(line.qty);
        var minus = qs('[data-bundle-qty="-1"]', card);
        if (minus) minus.disabled = line.qty <= 1;
        if (line.selected && variant && item) {
          selected.push({ title: item.title, qty: line.qty, variant: variant });
          subtotal += variant.price * line.qty;
        }
      });
      var ready = selected.length >= minItems;
      var discount = ready ? Math.round(subtotal * rate) : 0;
      var total = Math.max(0, subtotal - discount);
      var remaining = Math.max(0, minItems - selected.length);
      var count = qs('[data-bundle-count]', bundle);
      if (count) count.textContent = selected.length + (selected.length === 1 ? ' item' : ' items');
      var bar = qs('[data-bundle-progress]', bundle);
      if (bar) bar.style.width = Math.min(100, (selected.length / minItems) * 100) + '%';
      var status = qs('[data-bundle-status]', bundle);
      if (status) {
        status.textContent = remaining
          ? 'Add ' + remaining + ' more item' + (remaining === 1 ? '' : 's') + ' to build your bundle.'
          : 'Bundle ready — checkout when you are.';
      }
      var list = qs('[data-bundle-lines]', bundle);
      if (list) {
        list.innerHTML = selected.length
          ? selected.map(function (row) {
              return '<li><div><p>' + row.qty + '× ' + escapeHtml(row.title) + '</p><span class="dw-bundle-line-variant">' + escapeHtml(row.variant.title) + '</span></div><strong>' + formatMoney(row.variant.price * row.qty) + '</strong></li>';
            }).join('')
          : '<li class="dw-bundle-empty">Choose products to begin.</li>';
      }
      var sub = qs('[data-bundle-subtotal]', bundle);
      if (sub) {
        sub.textContent = formatMoney(subtotal);
        sub.classList.toggle('dw-bundle-strike', ready);
      }
      var off = qs('[data-bundle-discount]', bundle);
      if (off) off.textContent = ready ? '−' + formatMoney(discount) : '—';
      var grand = qs('[data-bundle-total]', bundle);
      if (grand) grand.textContent = formatMoney(total);
      var add = qs('[data-bundle-add]', bundle);
      if (add) {
        add.disabled = !ready;
        add.textContent = remaining
          ? 'Choose ' + remaining + ' more • ' + formatMoney(total)
          : 'Add Bundle To Cart • ' + formatMoney(total);
      }
      var note = qs('[data-bundle-note]', bundle);
      if (note) {
        note.textContent = ready
          ? '5% extra off is applied automatically when you add this bundle.'
          : 'Select 2+ products to apply the bundle offer.';
      }
    }

    var bundleReady = false;
    var paintBundleBase = paintBundle;
    paintBundle = function () {
      var before = bundleReady;
      paintBundleBase();
      var selectedCount = qsa('[data-bundle-card].is-selected', bundle).length;
      bundleReady = selectedCount >= minItems;
      if (bundleReady && !before) {
        burstConfetti(qs('.dw-bundle-offer', bundle) || qs('[data-bundle-add]', bundle));
      }
    };

    var rail = qs('[data-bundle-rail]', bundle);
    qsa('[data-bundle-scroll]', bundle).forEach(function (btn) {
      on(btn, 'click', function () {
        if (!rail) return;
        var dir = Number(btn.getAttribute('data-bundle-scroll'));
        rail.scrollBy({ left: dir * Math.min(340, rail.clientWidth * 0.8), behavior: 'smooth' });
      });
    });
    on(qs('[data-bundle-add]', bundle), 'click', function () {
      var items = [];
      Object.keys(lines).forEach(function (key) {
        var line = lines[key];
        var variant = variantFor(key);
        if (line.selected && variant && variant.available !== false) {
          items.push({ id: variant.id, quantity: line.qty });
        }
      });
      if (items.length < minItems) return;
      var button = qs('[data-bundle-add]', bundle);
      var discountCode = (bundle.getAttribute('data-discount-code') || '').trim();
      button.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items }),
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        if (!discountCode) return refreshCart();
        return applyDiscountCode(discountCode);
      }).then(function (cart) {
        if (cart) {
          cartCount(cart.item_count || 0);
          renderCart(cart);
        }
        burstConfetti(button);
        openCart();
        return cart;
      }).catch(function () {
        button.disabled = false;
        return null;
      }).then(function (cart) {
        paintBundle();
        if (cart && discountCode && !discountCodeApplied(cart, discountCode) && !(cart.total_discount > 0)) {
          var note = qs('[data-bundle-note]', bundle);
          if (note) note.textContent = 'Items are in your cart, but the 5% bundle discount did not apply.';
        }
      });
    });
    paintBundle();
  });

  /* Desktop nav opens on hover, same pattern as a catalog mega menu. */
  qsa('.ms-nav-drop').forEach(function (drop) {
    var timer;
    function canHover() {
      return window.matchMedia('(hover: hover) and (min-width: 1280px)').matches;
    }
    drop.addEventListener('mouseenter', function () {
      if (!canHover()) return;
      window.clearTimeout(timer);
      qsa('.ms-nav-drop').forEach(function (other) {
        if (other !== drop) other.removeAttribute('open');
      });
      drop.setAttribute('open', '');
    });
    drop.addEventListener('mouseleave', function () {
      if (!canHover()) return;
      timer = window.setTimeout(function () {
        drop.removeAttribute('open');
      }, 140);
    });
  });
  on(document, 'keydown', function (event) {
    if (event.key !== 'Escape') return;
    qsa('.ms-nav-drop[open]').forEach(function (drop) {
      drop.removeAttribute('open');
    });
  });

  /* Mobile drawer stack */
  qsa('[data-drawer-open]').forEach(function (btn) {
    on(btn, 'click', function () {
      var id = btn.getAttribute('data-drawer-open');
      qsa('[data-drawer-pane]', menuDrawer).forEach(function (pane) {
        pane.hidden = pane.getAttribute('data-drawer-pane') !== id;
      });
      var title = qs('[data-drawer-title]');
      if (title) title.textContent = btn.getAttribute('data-drawer-title') || 'Menu';
      var back = qs('[data-drawer-back]');
      if (back) back.hidden = false;
    });
  });
  on(qs('[data-drawer-back]'), 'click', function () {
    qsa('[data-drawer-pane]', menuDrawer).forEach(function (pane) {
      pane.hidden = pane.getAttribute('data-drawer-pane') !== 'root';
    });
    var title = qs('[data-drawer-title]');
    if (title) title.textContent = 'Menu';
    qs('[data-drawer-back]').hidden = true;
  });

  /* Authenticate — same VCQRU flow as the Next.js site */
  var auth = qs('[data-auth]');
  if (auth) {
    var VCQRU = 'https://www.vcqru.com/Info/MasterHandler.ashx';
    var COMP_ID = 'Comp-2122';
    var COMP_NAME = 'HERBSMITH WELLNESS LLP';
    var authCode = '';
    var authLat = '';
    var authLng = '';
    var mobileTimer = null;

    function authField(name) {
      return qs('[name="' + name + '"]', auth);
    }
    function setAuthError(name, message) {
      var node = qs('[data-auth-error="' + name + '"]', auth);
      if (node) node.textContent = message || '';
    }
    function clearAuthErrors() {
      qsa('[data-auth-error]', auth).forEach(function (node) {
        node.textContent = '';
      });
    }
    function setAuthLoading(on) {
      var overlay = qs('[data-auth-loading]', auth);
      if (overlay) overlay.hidden = !on;
    }
    function formatAuthCode(value) {
      var digits = String(value || '').replace(/\D/g, '').slice(0, 13);
      if (digits.length <= 5) return digits;
      return digits.slice(0, 5) + '-' + digits.slice(5);
    }
    function validCode(code) {
      return code && code.length === 14 && code.indexOf('-') === 5 && code.replace(/\D/g, '').length === 13;
    }
    function validMobile(mobile) {
      return /^[6-9]\d{9}$/.test(mobile);
    }
    function validName(name) {
      return /^[A-Za-z][A-Za-z\s'.-]{1,49}$/.test(String(name || '').trim());
    }
    function showAuthStep(next) {
      qsa('[data-auth-step]', auth).forEach(function (pane) {
        pane.hidden = pane.getAttribute('data-auth-step') !== next;
      });
      var order = { code: 0, fields: 1, message: 2 };
      qsa('[data-auth-pip]', auth).forEach(function (pip) {
        var id = pip.getAttribute('data-auth-pip');
        pip.classList.toggle('is-active', id === next);
        pip.classList.toggle('is-done', order[id] < order[next]);
      });
    }
    function vcqru(params) {
      var search = new URLSearchParams(params);
      return fetch(VCQRU + '?' + search.toString(), { method: 'GET', cache: 'no-store' }).then(function (res) {
        if (!res.ok) throw new Error('vcqru');
        return res.text();
      });
    }
    function warrantyCheck(raw) {
      var text = String(raw || '').replace(/\s+/g, ' ').trim();
      if (!text || /<html/i.test(raw)) return 'invalid';
      var company = ((text.split('&')[1] || '').split('~')[0] || '').trim();
      if (company) return company.toLowerCase() === COMP_NAME.toLowerCase() ? 'ok' : 'unassociated';
      if (text.toLowerCase() === COMP_NAME.toLowerCase()) return 'ok';
      return 'invalid';
    }
    function inferStatus(token, message) {
      var blob = (String(token || '') + ' ' + String(message || '')).toLowerCase();
      if (/already (been )?verified/.test(blob)) return 'already';
      if (/congratulat|purchased an authentic|product is genuine|product is authentic|successfully verified|thank you for authenticat/.test(blob)) return 'valid';
      if (/doesn't look right|does not look right|counterfeit|not genuine|not authentic|fake product|not valid|invalid/.test(blob)) return 'invalid';
      if (/^(failure|fail|failed|false|invalid|error)$/.test(String(token || '').trim().toLowerCase())) return 'invalid';
      return 'invalid';
    }
    function fallbackMessage(status) {
      if (status === 'already') return 'This code has already been verified earlier.';
      if (status === 'valid') return 'Your product has been verified successfully.';
      return 'This code is not valid. Check the scratched digits and try again.';
    }
    function showResult(status, message) {
      var box = qs('[data-auth-result]', auth);
      var title = qs('[data-auth-result-title]', auth);
      var body = qs('[data-auth-result-message]', auth);
      var label = status === 'valid' ? 'Verified genuine' : status === 'already' ? 'Already verified' : 'Not verified';
      if (box) box.setAttribute('data-status', status);
      if (title) title.textContent = label;
      if (body) body.textContent = message || fallbackMessage(status);
      showAuthStep('message');
    }
    function lookupPin(pin) {
      if (!/^\d{6}$/.test(pin)) return;
      fetch('https://api.postalpincode.in/pincode/' + pin)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var row = data && data[0];
          if (!row || row.Status !== 'Success' || !row.PostOffice || !row.PostOffice[0]) {
            setAuthError('pin', 'Please enter a valid pincode.');
            return;
          }
          var office = row.PostOffice[0];
          var city = authField('city');
          var state = authField('state');
          if (city && !city.value && office.District) city.value = office.District;
          if (state && !state.value && office.State) state.value = office.State;
          if (city) city.readOnly = true;
          if (state) state.readOnly = true;
          setAuthError('pin', '');
        })
        .catch(function () {});
    }
    function lookupConsumer(mobile) {
      if (!validMobile(mobile)) return;
      setAuthLoading(true);
      vcqru({ method: 'ConsumerDetailsByMobileNo', MobileNo: mobile, compid: COMP_ID })
        .then(function (data) {
          var parts = String(data || '').split('~');
          var name = authField('name');
          var pin = authField('pin');
          var city = authField('city');
          var state = authField('state');
          if (name && !name.value && validName(parts[0])) name.value = String(parts[0]).trim();
          if (pin && !pin.value && /^\d{6}$/.test(String(parts[6] || '').replace(/\D/g, '').slice(0, 6))) {
            pin.value = String(parts[6]).replace(/\D/g, '').slice(0, 6);
          }
          if (city && !city.value && parts[2] && !/[<>]|https?:/i.test(parts[2])) city.value = String(parts[2]).trim();
          if (state && !state.value && parts[3] && !/[<>]|https?:/i.test(parts[3])) state.value = String(parts[3]).trim();
          if (pin && pin.value && ((city && !city.value) || (state && !state.value))) lookupPin(pin.value);
        })
        .catch(function () {})
        .then(function () { setAuthLoading(false); });
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (pos) {
        authLat = String(pos.coords.latitude || '');
        authLng = String(pos.coords.longitude || '');
      }, function () {}, { enableHighAccuracy: false, timeout: 6000, maximumAge: 300000 });
    }

    on(authField('code'), 'input', function () {
      authField('code').value = formatAuthCode(authField('code').value);
      setAuthError('code', '');
    });
    on(authField('mobile'), 'input', function () {
      var next = authField('mobile').value.replace(/\D/g, '').slice(0, 10);
      authField('mobile').value = next;
      setAuthError('mobile', '');
      window.clearTimeout(mobileTimer);
      mobileTimer = window.setTimeout(function () { lookupConsumer(next); }, 450);
    });
    on(authField('pin'), 'input', function () {
      var next = authField('pin').value.replace(/\D/g, '').slice(0, 6);
      authField('pin').value = next;
      setAuthError('pin', '');
      var city = authField('city');
      var state = authField('state');
      if (next.length === 6) lookupPin(next);
      else {
        if (city) { city.value = ''; city.readOnly = false; }
        if (state) { state.value = ''; state.readOnly = false; }
      }
    });

    on(qs('[data-auth-step="code"]', auth), 'submit', function (event) {
      event.preventDefault();
      clearAuthErrors();
      authCode = formatAuthCode(authField('code').value);
      authField('code').value = authCode;
      if (!validCode(authCode)) {
        setAuthError('code', 'Use format 11111-11111111.');
        return;
      }
      var parts = authCode.split('-');
      setAuthLoading(true);
      vcqru({ method: 'chkwarranty', codeone: parts[0], codetwo: parts[1], lat: authLat, long: authLng })
        .then(function (data) {
          var check = warrantyCheck(data);
          if (check !== 'ok') {
            setAuthError('code', check === 'unassociated'
              ? 'This code is not a MuscleSmith authenticity code.'
              : 'This code is not valid. Check the scratched digits and try again.');
            return;
          }
          showAuthStep('fields');
          if (authField('mobile') && !authField('mobile').value) authField('mobile').focus();
        })
        .catch(function () {
          setAuthError('code', 'Unable to verify this code right now. Please try again.');
        })
        .then(function () { setAuthLoading(false); });
    });

    on(qs('[data-auth-step="fields"]', auth), 'submit', function (event) {
      event.preventDefault();
      clearAuthErrors();
      var name = authField('name').value.trim();
      var mobile = authField('mobile').value.trim();
      var pin = authField('pin').value.trim();
      var city = authField('city').value.trim();
      var state = authField('state').value.trim();
      if (!validName(name)) { setAuthError('name', 'Please enter a valid name.'); return; }
      if (!validMobile(mobile)) { setAuthError('mobile', 'Enter a valid 10-digit mobile number (starting 6–9).'); return; }
      if (!/^\d{6}$/.test(pin)) { setAuthError('pin', 'Please enter a valid 6-digit pincode.'); return; }
      if (!city) { setAuthError('city', 'Please enter a valid city name.'); return; }
      if (!state) { setAuthError('state', 'Please enter a valid state name.'); return; }
      setAuthLoading(true);
      vcqru({
        method: 'verifyotp',
        mobile: mobile,
        vCode: authCode,
        Latitude: authLat,
        Longitude: authLng,
        name: name,
        PinCode: pin,
        city: city,
        state: state,
        Comp_ID: COMP_ID,
        comp: COMP_NAME,
      }).then(function (data) {
        var parts = String(data || '').split('~');
        var status = inferStatus(parts[0], parts.slice(1).join('~') || data);
        var message = String(parts.slice(1).join('~') || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        showResult(status, message || fallbackMessage(status));
      }).catch(function () {
        setAuthError('mobile', 'Unable to submit right now. Please try again.');
      }).then(function () { setAuthLoading(false); });
    });

    on(qs('[data-auth-back]', auth), 'click', function () { showAuthStep('code'); });
    on(qs('[data-auth-again]', auth), 'click', function () {
      authCode = '';
      authField('code').value = '';
      clearAuthErrors();
      showAuthStep('code');
      authField('code').focus();
    });

    var params = new URLSearchParams(window.location.search);
    var incoming = formatAuthCode(params.get('code') || '');
    if (validCode(incoming)) {
      authField('code').value = incoming;
      qs('[data-auth-step="code"]', auth).requestSubmit();
    }
  }

  /* Reveal */
  if ('IntersectionObserver' in window) {
    var reveal = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('home-revealed');
        });
      },
      { threshold: 0.12 }
    );
    qsa('.ms-reveal').forEach(function (node) {
      reveal.observe(node);
    });
  } else {
    qsa('.ms-reveal').forEach(function (node) {
      node.classList.add('home-revealed');
    });
  }

  var rec = qs('[data-recommendations]');
  if (rec && rec.getAttribute('data-url')) {
    fetch(rec.getAttribute('data-url'))
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-recommendations]');
        if (next && next.innerHTML.trim()) rec.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }

  refreshCart();
  window.MuscleSmith = Object.assign(root, { formatMoney: formatMoney, addVariant: addVariant, refreshCart: refreshCart });

  var journalSearch = qs('.ms-journal-search');
  if (journalSearch && window.visualViewport) {
    var journalQuery = window.matchMedia('(max-width: 1023px)');
    var placeJournalSearch = function () {
      if (!journalQuery.matches) {
        journalSearch.style.bottom = '';
        return;
      }
      var viewport = window.visualViewport;
      var covered = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop);
      journalSearch.style.bottom = covered > 80
        ? covered + 'px'
        : '';
    };
    window.visualViewport.addEventListener('resize', placeJournalSearch);
    window.visualViewport.addEventListener('scroll', placeJournalSearch);
  }
})();
